(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Toggle the description textarea when the checkbox is checked.
    // Also hide "Buy it now" / dynamic checkout while it's checked: that button is a
    // Shopify-hosted cross-origin iframe and can't be intercepted by page JS, so it would
    // skip adding the alteration line item entirely. "Add to cart" is the only flow that
    // reliably adds both items together.
    document.addEventListener('change', function (e) {
      var checkbox = e.target.closest('[data-alteration-checkbox]');
      if (!checkbox) return;
      var addon = checkbox.closest('[data-alteration-addon]');
      var details = addon.querySelector('[data-alteration-details]');
      details.hidden = !checkbox.checked;
      if (!checkbox.checked) {
        addon.querySelector('[data-alteration-error]').hidden = true;
      }

      var form = checkbox.closest('form');
      var dynamicCheckout = form ? form.querySelector('.m-product-dynamic-checkout') : null;
      if (dynamicCheckout) {
        dynamicCheckout.style.display = checkbox.checked ? 'none' : '';
      }
      var notice = addon.querySelector('[data-alteration-checkout-notice]');
      if (notice) notice.hidden = !checkbox.checked;
    });

    // Intercept add-to-cart submissions in the capture phase so we run before
    // the theme's own product-form submit handler (which only adds one item).
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

        var addon = form.querySelector('[data-alteration-addon]');
        if (!addon) return;
        var checkbox = addon.querySelector('[data-alteration-checkbox]');
        if (!checkbox || !checkbox.checked) return;

        var textarea = addon.querySelector('[data-alteration-note]');
        var errorEl = addon.querySelector('[data-alteration-error]');
        var description = (textarea.value || '').trim();

        if (!description) {
          e.preventDefault();
          e.stopPropagation();
          errorEl.hidden = false;
          textarea.focus();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        errorEl.hidden = true;

        var alterationVariantId = addon.getAttribute('data-variant-id');
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var mainVariantId = idInput ? idInput.value : null;
        var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
        var titleEl = document.querySelector('h1');
        var productTitle = titleEl ? titleEl.textContent.trim() : document.title;

        if (!mainVariantId) {
          window.alert('Please select a variant before adding to cart.');
          return;
        }

        var submitButton = form.querySelector('[name="add"]');
        if (submitButton) submitButton.classList.add('m-spinner-loading');

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartEl = document.querySelector('m-cart-drawer');
        var payload = {
          items: [
            { id: parseInt(mainVariantId, 10), quantity: quantity },
            {
              id: parseInt(alterationVariantId, 10),
              quantity: 1,
              properties: {
                'Alteration Request': description,
                'For Product': productTitle,
              },
            },
          ],
        };

        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          payload.sections = cartEl.getSectionsToRender().map(function (s) {
            return s.id;
          });
          payload.sections_url = window.location.pathname;
        }

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function (data) {
            if (cartEl && typeof cartEl.renderContents === 'function') {
              cartEl.renderContents(data);
              if (window.MinimogEvents && window.MinimogTheme) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
              }
            } else {
              window.location.href = rootUrl + 'cart';
            }
          })
          .catch(function (err) {
            console.error('Alteration add-on: failed to add to cart', err);
            window.alert((err && err.description) || 'Something went wrong adding this item to your cart. Please try again.');
          })
          .finally(function () {
            if (submitButton) submitButton.classList.remove('m-spinner-loading');
          });
      },
      true
    );
  });
})();
